import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extractDateFrom'
})
export class ExtractDateFromPipe implements PipeTransform {

  transform(value: string, args: string[]): any {
      return value.substr(value.indexOf("__")+2,10).split("_").join("-");
  }

}
